import { action, computed, observable } from 'mobx';

import { ViewController } from '@estee/elc-service';
import { NumberFormatter } from '@estee/elc-formatters';

import { LoyaltyRepository } from '~repositories/LoyaltyRepository';
import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';
import { ITierLevelInfo } from '~exported/loyalty-tier-info/LoyaltyTierInfo';

export interface IConfigParamsPointFormat {
    formatPointsNextTier?: boolean;
    loyaltyTierInfo: ITierLevelInfo;
}

export interface ILoyaltyPointsInfoController {
    loyaltyRepository: LoyaltyRepository;
    numberFormatter: NumberFormatter;
}

class LoyaltyTierInfoController extends ViewController {
    private loyaltyRepository: LoyaltyRepository;
    private numberFormatter: NumberFormatter;
    @observable private configParams: IConfigParamsPointFormat;

    constructor({ loyaltyRepository, numberFormatter }: ILoyaltyPointsInfoController) {
        super();
        this.loyaltyRepository = loyaltyRepository;
        this.numberFormatter = numberFormatter;
    }

    @action
    public setConfigParams = (configParams: IConfigParamsPointFormat) => {
        this.configParams = configParams;
    };

    @computed public get formattedPointsValue() {
        const pointsValue = this.loyaltyRepository?.loyaltyInfo?.nextLevelPoints;

        return this.numberFormatter.formatNumber(pointsValue, {
            shouldUseGrouping: this.configParams.formatPointsNextTier
        });
    }

    @computed public get spendAmount() {
        const spendValue = this.loyaltyRepository?.loyaltyInfo?.nextLevelSpend;

        return String(spendValue);
    }

    @action
    public loaded = async () => {
        this.isLoading = true;
        await new LoadLoyaltyInfoUseCase().execute();
        this.isLoading = false;
    };

    @computed
    public get data() {
        return {
            loyaltyInfo: this.loyaltyRepository?.loyaltyInfo
        };
    }

    @computed
    public get configs() {
        return this.configParams;
    }
}

export default LoyaltyTierInfoController;
